import {EMAIL_MAKER_COMPONENT_TYPES} from '@EmailMakerReact/email-maker-react.constants';
import {registerEmailMakerSector} from '../../right-panel-registry';
import {deleteControl, lockControl} from '../shared/common-action-controls';

registerEmailMakerSector(EMAIL_MAKER_COMPONENT_TYPES.social.PMW_SOCIALS_ITEM, {
  title: window.i18next.t('pmwjs_social_link'),
  properties: [{control: lockControl}, {control: deleteControl}],
});
